// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Uled","content":"styles_content__1WL9T","row":"styles_row__30KyR","footer":"styles_footer__3rg7s","phraseLength":"styles_phraseLength__taZ3t"};